// 任务配置
export default {
    siteManagement: 'Site Management',
    siteName: 'Site Name',
    addSite: 'Add Site',
    tip_enterSiteName: 'Please enter a site name',
}